import { createFileRoute } from "@tanstack/react-router";
import LeadAnalytics from "@/features-root-user/dashboard/leads-analytics";
import { customerStateWidgetQueryOptions } from "@/features-root-user/service/dashboard";
import { queryClient } from "@/main";

export const Route = createFileRoute(
  "/_root/root-user/dashboard/lead-analytics",
)({
  component: LeadAnalytics,
  loader: async () => {
    queryClient.ensureQueryData(customerStateWidgetQueryOptions);
  },
});
